import errors from './fr/errors';
import formats from './fr/formats';
import main from './fr/main';

export default { ...main, ...errors, ...formats };
